import React from 'react';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import Account from '@material-ui/icons/AccountCircle';
// @material-ui/icons
// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import Clearfix from 'components/Clearfix/Clearfix.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';

import userProfileStyles from 'assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx';

import { compose, graphql } from 'react-apollo';

import selectStyles from 'assets/jss/material-dashboard-pro-react/customSelectStyle.jsx';
import { withSnackbar } from '../views/snackbar/SnackbarContext';
import { addAdmin } from './schema/auth-schema.graphql';
import localization from '../i18n/localization';
import tenantRoles from './tenantRoles';

class AddTenant extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      roles: [],
    };
  }

  onRolesChange = event => {
    this.setState({ roles: event.target.value });
  };

  onEmailChange = event => {
    this.setState({
      email: event.target.value,
    });
  };

  onPasswordChange = event => {
    this.setState({
      password: event.target.value,
    });
  };

  addAdmin = async () => {
    const { history, addAdmin, addNotification } = this.props;
    const { roles, email, password } = this.state;
    this.setState({ loading: true });
    try {
      await addAdmin({
        variables: {
          email,
          password,
          roles,
        },
      });
      addNotification('success', 'Admin hinzugef\u00fcgt');
      history.push('/tenants');
    } catch (error) {
      this.setState({ loading: false });
      addNotification(
        'danger',
        `Fehler beim erstellen eines admins. 
      ${error}`
      );
    }
  };

  render() {
    const { roles, email, password, loading } = this.state;
    const { classes } = this.props;
    return (
      <GridItem xs={12} sm={12} md={12} lg={12}>
        <Card>
          <CardHeader icon>
            <CardIcon color="rose">
              <Account />
            </CardIcon>
          </CardHeader>
          <CardBody>
            <div>
              <div
                style={{
                  marginTop: 20,
                  display: 'flex',
                  width: '100%',
                  alignItems: 'flex-start',
                }}
              >
                <div style={{ flex: 1 }}>
                  <Typography variant="headline" color="textSecondary">
                    Mandant hinzuf&uuml;gen
                  </Typography>
                </div>
              </div>
              <GridContainer>
                <GridItem xs={12} sm={12} md={6} lg={6}>
                  <CustomInput
                    labelText="Email"
                    inputProps={{
                      value: email,
                      onChange: this.onEmailChange,
                    }}
                    formControlProps={{
                      fullWidth: true,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6} lg={6}>
                  <CustomInput
                    labelText="Passwort"
                    inputProps={{
                      value: password,
                      onChange: this.onPasswordChange,
                    }}
                    formControlProps={{
                      fullWidth: true,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6} lg={6}>
                  <FormControl fullWidth className={classes.selectFormControl}>
                    <InputLabel
                      htmlFor="role-select"
                      className={classes.selectLabel}
                    >
                      Rollen
                    </InputLabel>
                    <Select
                      multiple
                      value={roles}
                      onChange={this.onRolesChange}
                      MenuProps={{ className: classes.selectMenu }}
                      classes={{ select: classes.select }}
                      inputProps={{
                        name: 'role-select',
                        id: 'role-select',
                      }}
                    >
                      {Object.keys(tenantRoles).map(role => (
                        <MenuItem
                          key={role}
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value={role}
                        >
                          {localization.de[role]}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </GridItem>
              </GridContainer>
              <Button
                disabled={loading}
                style={{ marginTop: 40 }}
                color="info"
                className={classes.updateProfileButton}
                onClick={this.addAdmin}
              >
                Hinzuf&uuml;gen
              </Button>
              <Clearfix />
            </div>
          </CardBody>
        </Card>
      </GridItem>
    );
  }
}

const enhance = compose(
  graphql(addAdmin, { name: 'addAdmin' }),
  withStyles({ ...userProfileStyles, ...selectStyles }),
  withSnackbar
);

export default enhance(AddTenant);



// WEBPACK FOOTER //
// ./src/auth/AddTenant.jsx